import { CatHeading } from '@blocks-react/components/Heading';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { useBreakpoint } from '@app/hooks';
import { useTranslation } from 'react-i18next';

const ContactUsFormDescription = () => {
  const MD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const [t] = useTranslation();

  return (
    <>
      <CatHeading variant={MD ? 'headline' : 'headline-lg'} decorator>
        {t('CONTACT_CAT_SUPPORT_TITLE')}
      </CatHeading>
    </>
  );
};

export default ContactUsFormDescription;
